import moment from "moment";
import React from "react";
import * as Yup from "yup";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*&#]{8,}$/;
const phoneRegex = /^\d{10}$/; 
const usernameRegex = /^[a-zA-Z0-9_.@-]+$/;
const usZipRegex = /^\d{5}(-\d{4})?$/;
const indiaZipRegex = /^[1-9][0-9]{5}$/;
const today = new Date();
const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(),today.getDate());
const lastMOnth = new Date(today.getFullYear(), today.getMonth() - 1 , 1);
const currentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
const firstNameRegex = /^[A-Z][a-z]*(?: [A-Z][a-z]*)*$/;

const lastNameRegex = /^[A-Z][a-z]*(?: [A-Z][a-z]*)*$/;
const addUser = {
  // userName: Yup.string().required("Required"),
  userName: Yup.string()
    .matches(usernameRegex, "User Name should not have Spaces")
    .required("Required"),
  // password: Yup.string().required("Required"),
  // firstName: Yup.string().required("Required").matches(firstNameRegex,"First Name starts with capital letter followed by small letters"),
  // lastName: Yup.string().required("Required").matches(lastNameRegex, "Last Name starts with capital letter followed by small letters"),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  gender: Yup.string().required("Required"),
  joinDate: Yup.date().required("Required") ,
  endDate: Yup.date().required("Required"),
  dateOfBirth: Yup.date().required("Required").max(eighteenYearsAgo,"user must be at least 18 years old and not future Date"),
  acctType: Yup.string().required("Required"),
  stsCd: Yup.string().required("Required"),
  // phone: Yup.string().required("Required"),
  phone: Yup.string()
    .matches(phoneRegex, "Invalid phone number")
    .required("Required"),
  email: Yup.string()
    .matches(emailRegex, "Invalid email format")
    .required("Required"),
  // email: Yup.string().email("Invalid email").required("Required"),
  // address: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  addressLine1: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  country: Yup.string().required("Required"),
   // reportsTo: Yup.string().required("Required"),
   zip: Yup.string()
    .required("Postal code is required")
    .test('zip-validation', 'Invalid ZIP code', function(value) {
      const { country } = this.parent;
      if (!value) return true;
      if (country === 'USA') {
        if (value.length > 5) {
          return this.createError({ message: 'ZIP code cannot exceed 5 digits' });
        }
        if (value.length > 0 && value.length < 5) {
          return this.createError({ message: 'ZIP code must be 5 digits' });
        }
        if (value.length === 5 && !usZipRegex.test(value)) {
          return this.createError({ message: 'Invalid US ZIP code format (e.g., 12345)' });
        }
      }

      if (country === 'IN') {
        if (value.length > 6) {
          return this.createError({ message: 'ZIP code cannot exceed 6 digits' });
        }
        if (value.length > 0 && value.length < 6) {
          return this.createError({ message: 'ZIP code must be 6 digits' });
        }
        if (value.length === 6 && !indiaZipRegex.test(value)) {
          return this.createError({ message: 'Invalid ZIP code' });
        }
      }

      return true;
    }),
};

const editUser = {
  dateOfBirth: Yup.date().required("Required").max(eighteenYearsAgo,"user must be at least 18 years old and not future Date"),
  stsCd: Yup.string().required("Required"),
  phone: Yup.string()
    .matches(phoneRegex, "Invalid phone number")
    .required("Required"),
    // .max(10, "Phone number cannot exceed 10 digits"),

  city: Yup.string().required("Required"),
  addressLine1: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  country: Yup.string().required("Required"),
  zip: Yup.string()
  .required("Zip code is required")
  .test('zip-validation', 'Invalid ZIP code', function(value) {
    const { country } = this.parent;
    if (!value) return true;
      
    if (country === 'USA') {
        if (value.length > 5) {
          return this.createError({ message: 'ZIP code cannot exceed 5 digits' });
        }
        if (value.length > 0 && value.length < 5) {
          return this.createError({ message: 'ZIP code must be 5 digits' });
        }
        if (value.length === 5 && !usZipRegex.test(value)) {
          return this.createError({ message: 'Invalid US ZIP code format (e.g., 12345)' });
        }
      }

      if (country === 'IN') {
        if (value.length > 6) {
          return this.createError({ message: 'ZIP code cannot exceed 6 digits' });
        }
        if (value.length > 0 && value.length < 6) {
          return this.createError({ message: 'ZIP code must be 6 digits' });
        }
        if (value.length === 6 && !indiaZipRegex.test(value)) {
          return this.createError({ message: 'Invalid ZIP code' });
        }
      }

      return true;
    }),
};

export const getValuesFromLocalstorage = (storageKey) => {
  const userDetails =
    storageKey === "accessToken"
      ? localStorage.getItem(storageKey)
      : JSON.parse(localStorage.getItem(storageKey));

  return userDetails || null;
};

export const SignupSchema = Yup.object().shape({
  userName: Yup.string().required("Username is Required"),
  // password: Yup.string("Enter your password")
  //   .min(7, "Password should be 7 characters length")
  //   .required("Password is Required")
    //.matches(passwordRegex, "Password don't matches criteria "),
});

export const ForgotPasswordSchema = Yup.object().shape({
  // email: Yup.string().email("Email is Required"),
  email: Yup.string()
    .required("Email is required")
    .matches(emailRegex, "This is not a valid email"),
});

export const ResetPasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .matches(passwordRegex, "Password don't matches criteria "),

  confirmPassword: Yup.string()
    .min(8, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    // .matches(passwordRegex,"Password don't matches")
    .oneOf([Yup.ref("newPassword"), null], "passwords must match"),
});

export const UpdatePasswordSchema = Yup.object().shape({
  oldPassword: Yup.string("old password is required").matches(
    passwordRegex,
    "Password don't matches criteria "
  ),
  newPassword: Yup.string()
    .min(6, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .matches(passwordRegex, "Password don't matches criteria "),
  confirmPassword: Yup.string()
    .min(6, "New Password is too short")
    .max(25, "New Password is too long")
    .required("Password is Required")
    .oneOf([Yup.ref("newPassword"), null], "passwords must match"),
});
export const EditUserSchema = Yup.object(editUser);
export const AddUserSchema = Yup.object({
  ...addUser,
  // password: Yup.string().required("Required"),
  password: Yup.string()
    .matches(
      passwordRegex,
      "Password must be at least 8 characters, contain one uppercase letter, one number, and one special character"
    )
    .required("Required"),
});

export const projectValidationSchema = Yup.object({
  userId: Yup.number().required("User ID is required"),
  // username: Yup.string().required("Username is required"),
  projectName: Yup.string().required("Project Name is required"),
  clientId: Yup.string().required("Client is required"),
  startDate: Yup.date().required("Start Date is required"),
  // endDate: Yup.date()
  //   .required("End Date is required")
  //   .min(Yup.ref("startDate"), "End date cannot be before start date"),
  budget: Yup.number().required("Budget is required"),
  netPay: Yup.number().required("Net Pay is required"),
});

export const clientValidationSchema = Yup.object({
  name: Yup.string().required("Client Name is required"),
  addressLine1: Yup.string().required("Address is required"),
  //addressLine2: Yup.string(),
  email: Yup.string()
    .nullable()
    .transform((value) => (value === "" ? null : value))
    .test('email-validation', 'Invalid email format', function(value) {
      if (!value) return true; // Skip validation if no value
      return emailRegex.test(value);
    }),
    
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip: Yup.string().required("ZIP is required") .max(5, "ZIP code cannot exceed 5 digits"),
});

const editClient = {
  name: Yup.string().required("Client Name is required"),
  addressLine1: Yup.string().required("Address is required"),
  addressLine2: Yup.string(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip: Yup.string().required("ZIP is required"),
};

export const EditClientSchema = Yup.object(editClient);
export const AddClientSchema = Yup.object(editClient);

export const employeeValidationSchema = Yup.object({
  userName: Yup.string().required("User Name required"),
  password: Yup.string().required("Password required"),
  firstName: Yup.string().required("First Name required"),
  lastName: Yup.string().required("Last Name required"),
  email: Yup.string().required("Email is required"),
  Gender: Yup.string().required("Gender is required"),
  joinDate: Yup.date().required("Join Date is required"),
  endDate: Yup.date().required("End Date is required"),
  phone: Yup.string().required("Phone Number is required"),
  accountType: Yup.string().required("Account type is required"),
  status: Yup.string().required("status is required"),
  reportsTo: Yup.string().required("Reporting to is required"),
  address1: Yup.string().required("Address is required"),
  address2: Yup.string().required("Address is required"),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  country: Yup.string().required("Country is required"),
  zip: Yup.string().required("Zip required"),
});

export const editvalidationSchema = Yup.object({
  userName: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  gender: Yup.string().required("Required"),
  joinDate: Yup.date().required("Required"),
  endDate: Yup.date(),
  accountType: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  address: Yup.string().required("Required"),
  city: Yup.string().required("Required"),
  state: Yup.string().required("Required"),
  country: Yup.string().required("Required"),
  zip: Yup.string()
    .test('zip-validation', function(value) {
      const { country } = this.parent;
      if (country === 'USA') {
        if (!usZipRegex.test(value)) {
          return this.createError({ message: 'Invalid US ZIP code format (e.g., 12345 or 12345-6789)' });
        }
      }
      if (country === 'IN') {
        if (!indiaZipRegex.test(value)) {
          return this.createError({ message: 'Invalid Indian PIN code format (6 digits required)' });
        }
      }
      return true;
    })
    .required('Postal code is required'),
  reportsTo: Yup.string().required("Required"),
});



export const timeSheetValidationSchema = Yup.object({
  projectId: Yup.string().required("Project is required"),
  work_location: Yup.string().required("Work location is required"),
  startDate: Yup.date().required("Start date is required"),
  endDate: Yup.date()
    .required("End date is required")
    .min(Yup.ref("startDate"), "End date must be before Start date"),
  total_hours: Yup.number()
    .required("Total hours are required")
    .positive("Total hours must be greater than 0"),
  holidays: Yup.array().of(
    Yup.object({
      date: Yup.date().required("Holiday date is required"),
      note: Yup.string().required("Note is required"),
    })
  ),
});
export const statusValidationSchema = Yup.object({
  // userId: Yup.object().required("Employee selection is required"),
  userStatus: Yup.string().required("Status is required"),
  startDate: Yup.date().required("Start date is required"),
  endDate: Yup.date()
    .required("End date is required"),
    // .min(Yup.ref("startDate"), "End date cannot be before start date"),
  statusCode: Yup.string().required("Status code is required"),
  // files: Yup.array()
  //   .min(1, "You must upload at least one file")
  //   .required("Files are required"),
});

export const documentValidationSchema = Yup.object({
  documentType: Yup.string().required("Document type is required"),

  others: Yup.string().when("documentType", {
    is: "OTHER",
    then: (schema) => schema.required("Please enter document type"),
    otherwise: (schema) => schema.notRequired(),
  }),

  issueDate: Yup.date().when("documentType", {
    is: (val) => val !== "OTHER",
    then: (schema) => schema.required("Issue Date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  expiryDate: Yup.date()
    .when("documentType", {
      is: (val) => val !== "OTHER",
      then: (schema) =>
        schema
          .required("Expiry Date is required")
          .min(moment().startOf("day"), "Expiry date cannot be in the past"),
      otherwise: (schema) => schema.notRequired(),
    }),

  file: Yup.mixed().required("File is required"),
});

export const AdminPreferenceSchema = Yup.object({
  companyName: Yup.string().required("Company Name is required"),
  timesheetEmails: Yup.string()
  .matches(emailRegex, "Invalid email format")
  .required("Required"),
  hrEmails: Yup.string()
  .matches(emailRegex, "Invalid email format")
  .required("Required"),
  accountsEmails: Yup.string()
  .matches(emailRegex, "Invalid email format")
  .required("Required"),  
  siteLink: Yup.string()
    .required("Site Link is required"),
    // .url("Invalid URL format"),
    phone: Yup.string()
    .matches(phoneRegex, "Invalid phone number")
    .required("Required"),
});
